import React,{useState, useEffect, useContext} from 'react'
import { Form, Button,Figure, Container } from 'react-bootstrap';
import { Store } from '../../Store';
import axios from 'axios';
import ToastIt from '../../components/Toast';

const UserProfile = () => {
     const { state } = useContext(Store);
   const { baseUrl,  userInfo } = state;
   const [userData, setUserData] = useState({
      username: '',
      email: '',
      phone: '',
      firstName: '',
      lastName: ''
   });

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [variance, setVariance] = useState("");

   useEffect(() => {
      const storedUserData = JSON.parse(localStorage.getItem('userInfo'));
      if (storedUserData) {
         setUserData(storedUserData);
      }
   }, []);

   const handleChange = (e) => {
      const { name, value } = e.target;
      setUserData((prevData) => ({
         ...prevData,
         [name]: name === 'username' ? value.toLowerCase() : value
      }));
   };
   
   const handleSubmit = async (e) => {
      e.preventDefault();
      try {
         const { data } = await axios.put(baseUrl+'/user/update-profile', userData, {
            headers: { Authorization: `Bearer ${userInfo.token}` }
         });
          const updatedUserInfo = { ...userInfo, apiKey: data.data.apiKey };
          localStorage.setItem('userInfo', JSON.stringify(updatedUserInfo));
         setToastMessage('Profile updated successfully');
         setVariance("success");
         setShowToast(true);
      } catch (error) {
         console.log(error)
         setToastMessage('Error updating profile', error.message);
         setVariance("danger");
         setShowToast(true);
      }
   };

   // const regenerateApiKey = async () => {
   //    try {
   //       const { data } = await axios.post(baseUrl + '/user/new-apikey', {}, {
   //          headers: { Authorization: `Bearer ${userInfo.token}` }
   //       });
   //       const updatedUserInfo = { ...userInfo, apiKey: data.apiKey };
   //       localStorage.setItem('userInfo', JSON.stringify(updatedUserInfo));
   //       localStorage.setItem('CurrUser', JSON.stringify(updatedUserInfo));
   //       setToastMessage('API Key regenerated successfully');
   //       setVariance("success");
   //       setShowToast(true);
   //       window.location.reload();
   //    } catch (error) {
   //       console.log(error);
   //       setToastMessage('Error regenerating API Key');
   //       setVariance("danger");
   //       setShowToast(true);
   //    }
   // };

return (
 <Container>
 <h3 className='text-center text-primary border-bottom'>MY PROFILE</h3>
 <div className='mx-auto d-flex justify-content-center'>
 <Figure className='text-center'>
<Figure.Image roundedCircle width={91} height={100} alt='user-image' src='/images/logo.png'></Figure.Image>
<Figure.Caption className=''>ID: <b>{userInfo?._id}</b></Figure.Caption>
<Figure.Caption className=''>Phone: <b>{userInfo?.phone}</b> </Figure.Caption>
<Figure.Caption className=''>Account Type: <b>{userInfo?.userLevel}</b> </Figure.Caption>
</Figure>
 </div>
 {/* <Alert>MY API KEY: <span style={{ cursor: 'pointer', color: 'red' }} title='click to copy' onClick={() => navigator.clipboard.writeText(userInfo.apiKey || '')}>{userInfo.apiKey ? userInfo.apiKey : ''}</span></Alert>
 <Button className='w-100' onClick={regenerateApiKey}>Regenerate API Key</Button> */}

 <Form onSubmit={handleSubmit}>
      <Form.Group controlId="username">
          <Form.Label>Username</Form.Label>
          <Form.Control
               type="text"
               name="username"
               value={userInfo.username}
               onChange={handleChange}
               required
          />
      </Form.Group>
      <Form.Group controlId="email">
          <Form.Label>Email</Form.Label>
          <Form.Control
               type="email"
               name="email"
               value={userInfo.email}
             readOnly
             title="Email cannot be changed"
          />
      </Form.Group>
      <Form.Group controlId="phone">
          <Form.Label>Phone</Form.Label>
          <Form.Control
               type="text"
               name="phone"
               value={userInfo.phone}
               onChange={handleChange}
               required
          />
      </Form.Group>
      {/* <Form.Group controlId="firstName">
          <Form.Label>First Name</Form.Label>
          <Form.Control
               type="text"
               name="firstName"
               value={userData.firstName}
               onChange={handleChange}
               required
          />
      </Form.Group>
      <Form.Group controlId="lastName">
          <Form.Label>Last Name</Form.Label>
          <Form.Control
               type="text"
               name="lastName"
               value={userData.lastName}
               onChange={handleChange}
               required
          />
      </Form.Group> */}
      <Button variant="primary" className='w-100 my-3' type="submit">
          Update Profile
      </Button>
 </Form>
          <ToastIt
             Variance={variance}
             Message={toastMessage}
             ShowToast={showToast}
             OnClose={() => setShowToast(false)}
          />
</Container>
)
}

export default UserProfile